module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d12-8fc517ad4d3a3cac8a4c856cc7e55e9d.jpg";